export const NotFoundIcon = () => (
  <svg width="292" height="196" viewBox="0 0 292 196" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.2"
      d="M292 172.541C292 185.497 226.639 196 145.994 196C65.3503 196 0 185.497 0 172.541C0 159.584 65.3725 149.082 146.006 149.082C226.639 149.082 292.011 159.584 292.011 172.541H292Z"
      fill="#231F20"
    />
    <path
      d="M261.866 167.178H30.1446C29.8899 167.8 29.746 168.178 29.746 168.178C27.7747 173.096 30.488 177.126 35.7815 177.126H256.23C261.523 177.126 264.236 173.096 262.265 168.178L261.866 167.178Z"
      fill="#DFDCD8"
    />
    <path
      d="M261.435 166.246L243.616 121.803C243.029 120.338 241.257 119.139 239.684 119.139H52.3157C50.7431 119.139 48.9712 120.338 48.3843 121.803L36.59 151.213L30.5655 166.246C28.6053 171.131 31.3075 175.128 36.5568 175.128H116.858L116.902 174.839C116.935 174.606 117.445 174.417 118.043 174.417H174.19C174.777 174.417 175.275 174.606 175.309 174.839L175.342 175.128H255.465C260.715 175.128 263.417 171.131 261.457 166.246H261.435Z"
      fill="white"
    />
    <path
      d="M237.137 0H54.8739C51.7057 0 49.1373 2.57481 49.1373 5.75099V113.388C49.1373 116.564 51.7057 119.139 54.8739 119.139H237.137C240.305 119.139 242.874 116.564 242.874 113.388V5.75099C242.874 2.57481 240.305 0 237.137 0Z"
      fill="white"
    />
    <path
      d="M233.316 7.66058H58.6946C57.6365 7.66058 56.7787 8.52051 56.7787 9.58128V109.557C56.7787 110.618 57.6365 111.478 58.6946 111.478H233.316C234.375 111.478 235.232 110.618 235.232 109.557V9.58128C235.232 8.52051 234.375 7.66058 233.316 7.66058Z"
      fill="#7C7C7C"
    />
    <path
      d="M171.211 172.696H120.723C120.158 172.696 119.737 172.197 119.826 171.642L121.952 158.308C122.063 157.586 122.683 157.064 123.414 157.064H168.952C169.594 157.064 170.148 157.542 170.236 158.174L172.186 171.586C172.263 172.174 171.798 172.696 171.211 172.696Z"
      fill="#DFDCD8"
    />
    <path
      d="M74.2874 134.449H65.6161C65.3946 134.449 65.2507 134.382 65.2839 134.305L66.5685 131.118C66.6017 131.04 66.8011 130.974 67.0115 130.974H75.5388C75.7492 130.974 75.9043 131.04 75.8711 131.118L74.7304 134.305C74.6972 134.382 74.4978 134.449 74.2874 134.449Z"
      fill="#4D555A"
    />
    <path
      d="M90.3011 138.623H81.4415C81.22 138.623 81.065 138.557 81.0871 138.468L82.1392 135.148C82.1613 135.071 82.3607 135.004 82.5822 135.004H91.2867C91.5082 135.004 91.6632 135.071 91.6411 135.148L90.744 138.468C90.7219 138.557 90.5225 138.623 90.3011 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M91.7518 142.975H82.704C82.4825 142.975 82.3164 142.909 82.3496 142.82L83.4017 139.367C83.4238 139.278 83.6232 139.212 83.8446 139.212H92.7264C92.9478 139.212 93.114 139.278 93.0918 139.367L92.1948 142.82C92.1726 142.909 91.9733 142.975 91.7407 142.975H91.7518Z"
      fill="#4D555A"
    />
    <path
      d="M96.846 147.516H87.5989C87.3663 147.516 87.2002 147.439 87.2224 147.35L88.2191 143.741C88.2412 143.653 88.4516 143.586 88.6731 143.586H97.7431C97.9646 143.586 98.1307 143.653 98.1196 143.741L97.3001 147.35C97.278 147.439 97.0786 147.516 96.846 147.516Z"
      fill="#4D555A"
    />
    <path
      d="M67.676 154.233H58.2516C57.9969 154.233 57.8308 154.155 57.8751 154.044L59.6027 149.759C59.647 149.659 59.8685 149.581 60.1232 149.581H69.3482C69.5918 149.581 69.769 149.659 69.7247 149.759L68.1965 154.044C68.1632 154.144 67.9307 154.233 67.676 154.233Z"
      fill="#4D555A"
    />
    <path
      d="M80.2565 154.233H70.8322C70.5775 154.233 70.4113 154.155 70.4446 154.044L71.9285 149.759C71.9618 149.659 72.1833 149.581 72.438 149.581H81.663C81.9066 149.581 82.0838 149.659 82.0506 149.759L80.766 154.044C80.7327 154.144 80.5112 154.233 80.2565 154.233Z"
      fill="#4D555A"
    />
    <path
      d="M92.4606 154.233H83.0362C82.7815 154.233 82.6043 154.155 82.6375 154.044L83.8779 149.759C83.9111 149.659 84.1326 149.581 84.3762 149.581H93.6012C93.8449 149.581 94.0221 149.659 93.9999 149.759L92.9589 154.044C92.9368 154.144 92.7153 154.233 92.4606 154.233Z"
      fill="#4D555A"
    />
    <path
      d="M107.843 154.233H95.4064C95.1184 154.233 94.908 154.144 94.9412 154.022L95.9269 149.792C95.949 149.681 96.2037 149.592 96.4806 149.592H108.651C108.928 149.592 109.139 149.681 109.128 149.792L108.397 154.022C108.375 154.144 108.131 154.233 107.843 154.233Z"
      fill="#4D555A"
    />
    <path
      d="M184.323 154.233H171.887C171.599 154.233 171.355 154.144 171.344 154.022L170.846 149.792C170.834 149.681 171.045 149.592 171.333 149.592H183.504C183.78 149.592 184.024 149.681 184.046 149.792L184.81 154.022C184.833 154.144 184.611 154.233 184.334 154.233H184.323Z"
      fill="#4D555A"
    />
    <path
      d="M196.904 154.233H187.612C187.369 154.233 187.147 154.155 187.125 154.044L186.305 149.759C186.283 149.659 186.472 149.581 186.715 149.581H195.807C196.051 149.581 196.272 149.659 196.295 149.759L197.313 154.044C197.336 154.144 197.158 154.233 196.904 154.233Z"
      fill="#4D555A"
    />
    <path
      d="M168.786 154.233H111.42C110.822 154.233 110.368 154.033 110.401 153.789L111.021 150.014C111.055 149.781 111.564 149.592 112.162 149.592H168.309C168.896 149.592 169.395 149.781 169.428 150.014L169.849 153.789C169.871 154.033 169.406 154.233 168.808 154.233H168.786Z"
      fill="#4D555A"
    />
    <path
      d="M108.851 147.516H99.6036C99.371 147.516 99.2049 147.439 99.2271 147.35L100.024 143.741C100.047 143.653 100.246 143.586 100.467 143.586H109.537C109.759 143.586 109.936 143.653 109.914 143.741L109.294 147.35C109.283 147.439 109.083 147.516 108.851 147.516Z"
      fill="#4D555A"
    />
    <path
      d="M120.855 147.516H111.608C111.376 147.516 111.199 147.439 111.221 147.35L111.808 143.741C111.819 143.653 112.018 143.586 112.24 143.586H121.31C121.531 143.586 121.708 143.653 121.697 143.741L121.276 147.35C121.276 147.439 121.066 147.516 120.844 147.516H120.855Z"
      fill="#4D555A"
    />
    <path
      d="M132.86 147.516H123.613C123.38 147.516 123.203 147.439 123.214 147.35L123.602 143.741C123.602 143.653 123.801 143.586 124.023 143.586H133.093C133.314 143.586 133.502 143.653 133.491 143.741L133.281 147.35C133.281 147.439 133.082 147.516 132.849 147.516H132.86Z"
      fill="#4D555A"
    />
    <path
      d="M144.865 147.516H135.618C135.385 147.516 135.208 147.439 135.208 147.35L135.385 143.741C135.385 143.653 135.573 143.586 135.806 143.586H144.876C145.097 143.586 145.286 143.653 145.286 143.741V147.35C145.286 147.439 145.086 147.516 144.865 147.516Z"
      fill="#4D555A"
    />
    <path
      d="M156.87 147.516H147.622C147.39 147.516 147.202 147.439 147.202 147.35L147.179 143.741C147.179 143.653 147.357 143.586 147.589 143.586H156.659C156.881 143.586 157.069 143.653 157.08 143.741L157.279 147.35C157.279 147.439 157.102 147.516 156.87 147.516Z"
      fill="#4D555A"
    />
    <path
      d="M168.874 147.516H159.627C159.395 147.516 159.206 147.439 159.195 147.35L158.963 143.741C158.963 143.653 159.14 143.586 159.361 143.586H168.431C168.653 143.586 168.852 143.653 168.852 143.741L169.251 147.35C169.251 147.439 169.085 147.516 168.852 147.516H168.874Z"
      fill="#4D555A"
    />
    <path
      d="M180.879 147.516H171.632C171.399 147.516 171.211 147.439 171.2 147.35L170.768 143.741C170.768 143.653 170.934 143.586 171.156 143.586H180.226C180.447 143.586 180.646 143.653 180.657 143.741L181.267 147.35C181.278 147.439 181.112 147.516 180.879 147.516Z"
      fill="#4D555A"
    />
    <path
      d="M192.884 147.516H183.637C183.404 147.516 183.205 147.439 183.194 147.35L182.551 143.741C182.54 143.653 182.706 143.586 182.928 143.586H191.998C192.219 143.586 192.419 143.653 192.441 143.741L193.249 147.35C193.271 147.439 193.094 147.516 192.873 147.516H192.884Z"
      fill="#4D555A"
    />
    <path
      d="M103.601 142.975H94.5536C94.3321 142.975 94.166 142.909 94.1882 142.82L95.052 139.367C95.0741 139.278 95.2735 139.212 95.495 139.212H104.377C104.598 139.212 104.764 139.278 104.742 139.367L104.044 142.82C104.022 142.909 103.834 142.975 103.601 142.975Z"
      fill="#4D555A"
    />
    <path
      d="M115.462 142.975H106.414C106.193 142.975 106.016 142.909 106.038 142.82L106.702 139.367C106.713 139.278 106.913 139.212 107.134 139.212H116.016C116.237 139.212 116.404 139.278 116.392 139.367L115.894 142.82C115.883 142.909 115.684 142.975 115.462 142.975Z"
      fill="#4D555A"
    />
    <path
      d="M127.323 142.975H118.275C118.054 142.975 117.876 142.909 117.888 142.82L118.353 139.367C118.364 139.278 118.552 139.212 118.773 139.212H127.655C127.877 139.212 128.054 139.278 128.043 139.367L127.744 142.82C127.744 142.909 127.544 142.975 127.323 142.975Z"
      fill="#4D555A"
    />
    <path
      d="M139.106 142.975H130.058C129.837 142.975 129.66 142.909 129.66 142.82L129.925 139.367C129.925 139.278 130.114 139.212 130.335 139.212H139.217C139.438 139.212 139.616 139.278 139.616 139.367L139.516 142.82C139.516 142.909 139.328 142.975 139.106 142.975Z"
      fill="#4D555A"
    />
    <path
      d="M150.967 142.975H141.919C141.698 142.975 141.509 142.909 141.509 142.82L141.576 139.367C141.576 139.278 141.753 139.212 141.974 139.212H150.856C151.078 139.212 151.255 139.278 151.266 139.367L151.354 142.82C151.354 142.909 151.177 142.975 150.956 142.975H150.967Z"
      fill="#4D555A"
    />
    <path
      d="M162.307 142.975H153.259C153.038 142.975 152.85 142.909 152.85 142.82L152.728 139.367C152.728 139.278 152.905 139.212 153.126 139.212H162.008C162.23 139.212 162.418 139.278 162.418 139.367L162.706 142.82C162.706 142.909 162.54 142.975 162.307 142.975Z"
      fill="#4D555A"
    />
    <path
      d="M174.057 142.975H165.009C164.788 142.975 164.6 142.909 164.588 142.82L164.278 139.367C164.278 139.278 164.444 139.212 164.666 139.212H173.548C173.769 139.212 173.957 139.278 173.969 139.367L174.445 142.82C174.456 142.909 174.279 142.975 174.057 142.975Z"
      fill="#4D555A"
    />
    <path
      d="M185.807 142.975H176.759C176.538 142.975 176.338 142.909 176.327 142.82L175.818 139.367C175.807 139.278 175.973 139.212 176.194 139.212H185.076C185.298 139.212 185.486 139.278 185.508 139.367L186.184 142.82C186.206 142.909 186.029 142.975 185.807 142.975Z"
      fill="#4D555A"
    />
    <path
      d="M197.48 142.975H188.432C188.21 142.975 188.011 142.909 187.989 142.82L187.291 139.367C187.269 139.278 187.435 139.212 187.657 139.212H196.538C196.76 139.212 196.959 139.278 196.981 139.367L197.845 142.82C197.867 142.909 197.701 142.975 197.48 142.975Z"
      fill="#4D555A"
    />
    <path
      d="M209.163 142.975H200.115C199.894 142.975 199.683 142.909 199.661 142.82L198.764 139.367C198.742 139.278 198.908 139.212 199.13 139.212H208.011C208.233 139.212 208.432 139.278 208.454 139.367L209.518 142.82C209.54 142.909 209.385 142.975 209.163 142.975Z"
      fill="#4D555A"
    />
    <path
      d="M204.778 147.516H195.53C195.298 147.516 195.099 147.439 195.076 147.35L194.235 143.741C194.213 143.653 194.379 143.586 194.611 143.586H203.681C203.903 143.586 204.113 143.653 204.135 143.741L205.143 147.35C205.165 147.439 204.999 147.516 204.778 147.516Z"
      fill="#4D555A"
    />
    <path
      d="M229.85 142.975H212.386C212.076 142.975 211.799 142.876 211.755 142.753L210.691 139.412C210.658 139.289 210.869 139.201 211.179 139.201H228.333C228.632 139.201 228.92 139.289 228.964 139.412L230.326 142.753C230.371 142.876 230.16 142.975 229.85 142.975Z"
      fill="#4D555A"
    />
    <path
      d="M231.6 147.516H207.657C207.292 147.516 206.959 147.394 206.926 147.25L205.94 143.83C205.896 143.686 206.162 143.575 206.516 143.575H230.005C230.36 143.575 230.703 143.686 230.758 143.83L232.154 147.25C232.209 147.394 231.965 147.516 231.6 147.516Z"
      fill="#4D555A"
    />
    <path
      d="M79.9907 142.975H62.3381C62.028 142.975 61.8176 142.876 61.8619 142.753L63.213 139.412C63.2573 139.289 63.5452 139.201 63.8553 139.201H81.1868C81.4969 139.201 81.7073 139.289 81.6741 139.412L80.622 142.753C80.5888 142.876 80.3008 142.975 79.9907 142.975Z"
      fill="#4D555A"
    />
    <path
      d="M84.6863 147.516H60.4C60.0346 147.516 59.7799 147.394 59.8463 147.25L61.2306 143.83C61.286 143.686 61.6293 143.575 61.9837 143.575H85.8159C86.1814 143.575 86.4361 143.686 86.3918 143.83L85.4172 147.25C85.3729 147.394 85.0407 147.516 84.6752 147.516H84.6863Z"
      fill="#4D555A"
    />
    <path
      d="M101.852 138.623H92.9921C92.7707 138.623 92.6156 138.557 92.6267 138.468L93.4905 135.148C93.5126 135.071 93.7009 135.004 93.9224 135.004H102.627C102.848 135.004 103.003 135.071 102.992 135.148L102.284 138.468C102.261 138.557 102.073 138.623 101.852 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M113.325 138.623H104.465C104.244 138.623 104.078 138.557 104.1 138.468L104.775 135.148C104.786 135.071 104.986 135.004 105.196 135.004H113.901C114.122 135.004 114.277 135.071 114.266 135.148L113.746 138.468C113.735 138.557 113.546 138.623 113.325 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M124.875 138.623H116.016C115.794 138.623 115.628 138.557 115.639 138.468L116.127 135.148C116.138 135.071 116.326 135.004 116.536 135.004H125.241C125.462 135.004 125.629 135.071 125.617 135.148L125.285 138.468C125.285 138.557 125.086 138.623 124.875 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M136.426 138.623H127.567C127.345 138.623 127.168 138.557 127.179 138.468L127.478 135.148C127.478 135.071 127.666 135.004 127.888 135.004H136.592C136.814 135.004 136.98 135.071 136.98 135.148L136.836 138.468C136.836 138.557 136.648 138.623 136.426 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M147.91 138.623H139.051C138.829 138.623 138.652 138.557 138.652 138.468L138.763 135.148C138.763 135.071 138.94 135.004 139.162 135.004H147.866C148.088 135.004 148.254 135.071 148.265 135.148L148.309 138.468C148.309 138.557 148.132 138.623 147.91 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M159.129 138.623H150.269C150.048 138.623 149.871 138.557 149.871 138.468L149.804 135.148C149.804 135.071 149.981 135.004 150.192 135.004H158.896C159.118 135.004 159.295 135.071 159.295 135.148L159.516 138.468C159.516 138.557 159.35 138.623 159.129 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M170.768 138.623H161.908C161.687 138.623 161.51 138.557 161.499 138.468L161.244 135.148C161.244 135.071 161.41 135.004 161.621 135.004H170.325C170.547 135.004 170.724 135.071 170.735 135.148L171.145 138.468C171.145 138.557 170.989 138.623 170.768 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M182.274 138.623H173.415C173.193 138.623 173.005 138.557 172.994 138.468L172.551 135.148C172.551 135.071 172.706 135.004 172.927 135.004H181.632C181.854 135.004 182.031 135.071 182.053 135.148L182.651 138.468C182.662 138.557 182.496 138.623 182.274 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M193.581 138.623H184.722C184.5 138.623 184.312 138.557 184.29 138.468L183.659 135.148C183.648 135.071 183.803 135.004 184.024 135.004H192.729C192.95 135.004 193.138 135.071 193.161 135.148L193.947 138.468C193.969 138.557 193.803 138.623 193.581 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M205.365 138.623H196.505C196.284 138.623 196.084 138.557 196.073 138.468L195.254 135.148C195.231 135.071 195.398 135.004 195.608 135.004H204.313C204.534 135.004 204.722 135.071 204.744 135.148L205.719 138.468C205.741 138.557 205.586 138.623 205.365 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M216.638 138.623H207.779C207.557 138.623 207.358 138.557 207.336 138.468L206.328 135.148C206.306 135.071 206.461 135.004 206.671 135.004H215.376C215.597 135.004 215.797 135.071 215.819 135.148L216.982 138.468C217.015 138.557 216.86 138.623 216.638 138.623Z"
      fill="#4D555A"
    />
    <path
      d="M228.233 138.623H219.374C219.152 138.623 218.953 138.557 218.92 138.468L217.724 135.148C217.69 135.071 217.845 135.004 218.067 135.004H226.771C226.993 135.004 227.192 135.071 227.226 135.148L228.577 138.468C228.61 138.557 228.455 138.623 228.244 138.623H228.233Z"
      fill="#4D555A"
    />
    <path
      d="M85.7605 134.449H77.0892C76.8677 134.449 76.7238 134.382 76.7459 134.305L77.8534 131.118C77.8755 131.04 78.0749 130.974 78.2853 130.974H86.8126C87.023 130.974 87.1781 131.04 87.1559 131.118L86.2035 134.305C86.1814 134.382 85.982 134.449 85.7716 134.449H85.7605Z"
      fill="#4D555A"
    />
    <path
      d="M96.8903 134.449H88.2191C88.0086 134.449 87.8425 134.382 87.8757 134.305L88.806 131.118C88.8281 131.04 89.0164 130.974 89.2268 130.974H97.7541C97.9646 130.974 98.1196 131.04 98.1085 131.118L97.3333 134.305C97.3112 134.382 97.1229 134.449 96.9014 134.449H96.8903Z"
      fill="#4D555A"
    />
    <path
      d="M108.286 134.449H99.6147C99.3932 134.449 99.2381 134.382 99.2603 134.305L100.002 131.118C100.024 131.04 100.213 130.974 100.423 130.974H108.95C109.161 130.974 109.327 131.04 109.305 131.118L108.718 134.305C108.707 134.382 108.519 134.449 108.297 134.449H108.286Z"
      fill="#4D555A"
    />
    <path
      d="M119.416 134.449H110.744C110.523 134.449 110.368 134.382 110.379 134.305L110.944 131.118C110.955 131.04 111.143 130.974 111.354 130.974H119.881C120.091 130.974 120.257 131.04 120.246 131.118L119.837 134.305C119.837 134.382 119.637 134.449 119.427 134.449H119.416Z"
      fill="#4D555A"
    />
    <path
      d="M130.878 134.449H122.207C121.985 134.449 121.819 134.382 121.83 134.305L122.218 131.118C122.218 131.04 122.406 130.974 122.616 130.974H131.144C131.354 130.974 131.52 131.04 131.52 131.118L131.288 134.305C131.288 134.382 131.099 134.449 130.889 134.449H130.878Z"
      fill="#4D555A"
    />
    <path
      d="M141.908 134.449H133.237C133.015 134.449 132.849 134.382 132.86 134.305L133.071 131.118C133.071 131.04 133.248 130.974 133.469 130.974H141.997C142.207 130.974 142.384 131.04 142.373 131.118L142.318 134.305C142.318 134.382 142.141 134.449 141.919 134.449H141.908Z"
      fill="#4D555A"
    />
    <path
      d="M153.359 134.449H144.688C144.466 134.449 144.3 134.382 144.3 134.305L144.322 131.118C144.322 131.04 144.499 130.974 144.71 130.974H153.237C153.448 130.974 153.625 131.04 153.625 131.118L153.758 134.305C153.758 134.382 153.592 134.449 153.37 134.449H153.359Z"
      fill="#4D555A"
    />
    <path
      d="M164.478 134.449H155.806C155.596 134.449 155.408 134.382 155.408 134.305L155.253 131.118C155.253 131.04 155.419 130.974 155.629 130.974H164.157C164.367 130.974 164.544 131.04 164.555 131.118L164.865 134.305C164.865 134.382 164.699 134.449 164.489 134.449H164.478Z"
      fill="#4D555A"
    />
    <path
      d="M175.907 134.449H167.235C167.014 134.449 166.837 134.382 166.826 134.305L166.493 131.118C166.493 131.04 166.648 130.974 166.859 130.974H175.386C175.596 130.974 175.785 131.04 175.796 131.118L176.283 134.305C176.294 134.382 176.128 134.449 175.918 134.449H175.907Z"
      fill="#4D555A"
    />
    <path
      d="M187.313 134.449H178.642C178.432 134.449 178.243 134.382 178.232 134.305L177.712 131.118C177.701 131.04 177.856 130.974 178.077 130.974H186.604C186.815 130.974 187.003 131.04 187.014 131.118L187.69 134.305C187.712 134.382 187.546 134.449 187.324 134.449H187.313Z"
      fill="#4D555A"
    />
    <path
      d="M198.609 134.449H189.938C189.716 134.449 189.528 134.382 189.517 134.305L188.819 131.118C188.797 131.04 188.963 130.974 189.174 130.974H197.701C197.911 130.974 198.1 131.04 198.122 131.118L198.975 134.305C198.997 134.382 198.842 134.449 198.62 134.449H198.609Z"
      fill="#4D555A"
    />
    <path
      d="M209.451 134.449H200.78C200.558 134.449 200.37 134.382 200.348 134.305L199.473 131.118C199.451 131.04 199.606 130.974 199.816 130.974H208.344C208.554 130.974 208.753 131.04 208.776 131.118L209.794 134.305C209.816 134.382 209.661 134.449 209.451 134.449Z"
      fill="#4D555A"
    />
    <path
      d="M225.719 134.449H212.74C212.142 134.449 211.588 134.271 211.522 134.049L210.636 131.374C210.57 131.151 210.979 130.985 211.577 130.985H224.324C224.911 130.985 225.465 131.163 225.553 131.374L226.639 134.049C226.727 134.271 226.317 134.449 225.719 134.449Z"
      fill="#4D555A"
    />
    <path
      d="M76.3251 128.098H67.8974C67.687 128.098 67.5431 128.054 67.5763 127.987L68.8277 125.623C68.8609 125.567 69.0492 125.523 69.2596 125.523H77.5322C77.7426 125.523 77.8866 125.567 77.8534 125.623L76.7459 127.987C76.7238 128.043 76.5244 128.098 76.314 128.098H76.3251Z"
      fill="#4D555A"
    />
    <path
      d="M87.6764 128.098H79.2487C79.0383 128.098 78.8944 128.054 78.9165 127.987L79.9907 125.623C80.0129 125.567 80.2012 125.523 80.4116 125.523H88.6842C88.8946 125.523 89.0386 125.567 89.0164 125.623L88.0972 127.987C88.0751 128.043 87.8868 128.098 87.6764 128.098Z"
      fill="#4D555A"
    />
    <path
      d="M99.0277 128.098H90.6001C90.3896 128.098 90.2346 128.054 90.2568 127.987L91.1538 125.623C91.1759 125.567 91.3642 125.523 91.5635 125.523H99.8362C100.047 125.523 100.191 125.567 100.179 125.623L99.4264 127.987C99.4043 128.043 99.2271 128.098 99.0167 128.098H99.0277Z"
      fill="#4D555A"
    />
    <path
      d="M110.379 128.098H101.951C101.741 128.098 101.586 128.054 101.608 127.987L102.328 125.623C102.35 125.567 102.527 125.523 102.738 125.523H111.01C111.221 125.523 111.376 125.567 111.354 125.623L110.778 127.987C110.767 128.043 110.578 128.098 110.368 128.098H110.379Z"
      fill="#4D555A"
    />
    <path
      d="M121.73 128.098H113.303C113.092 128.098 112.937 128.054 112.948 127.987L113.502 125.623C113.513 125.567 113.69 125.523 113.901 125.523H122.173C122.384 125.523 122.539 125.567 122.528 125.623L122.129 127.987C122.129 128.043 121.941 128.098 121.73 128.098Z"
      fill="#4D555A"
    />
    <path
      d="M133.082 128.098H124.654C124.444 128.098 124.277 128.054 124.289 127.987L124.665 125.623C124.665 125.567 124.853 125.523 125.053 125.523H133.325C133.536 125.523 133.691 125.567 133.691 125.623L133.469 127.987C133.469 128.043 133.292 128.098 133.082 128.098Z"
      fill="#4D555A"
    />
    <path
      d="M144.433 128.098H136.005C135.795 128.098 135.629 128.054 135.64 127.987L135.839 125.623C135.839 125.567 136.016 125.523 136.216 125.523H144.488C144.699 125.523 144.865 125.567 144.865 125.623L144.809 127.987C144.809 128.043 144.632 128.098 144.422 128.098H144.433Z"
      fill="#4D555A"
    />
    <path
      d="M155.718 128.098H147.29C147.08 128.098 146.914 128.054 146.914 127.987L146.936 125.623C146.936 125.567 147.102 125.523 147.312 125.523H155.585C155.795 125.523 155.961 125.567 155.961 125.623L156.083 127.987C156.083 128.043 155.917 128.098 155.707 128.098H155.718Z"
      fill="#4D555A"
    />
    <path
      d="M167.058 128.098H158.63C158.42 128.098 158.243 128.054 158.243 127.987L158.088 125.623C158.088 125.567 158.243 125.523 158.453 125.523H166.726C166.936 125.523 167.102 125.567 167.113 125.623L167.412 127.987C167.412 128.043 167.257 128.098 167.047 128.098H167.058Z"
      fill="#4D555A"
    />
    <path
      d="M178.409 128.098H169.982C169.771 128.098 169.594 128.054 169.583 127.987L169.251 125.623C169.251 125.567 169.406 125.523 169.605 125.523H177.878C178.088 125.523 178.265 125.567 178.276 125.623L178.753 127.987C178.764 128.043 178.609 128.098 178.398 128.098H178.409Z"
      fill="#4D555A"
    />
    <path
      d="M189.772 128.098H181.344C181.134 128.098 180.956 128.054 180.945 127.987L180.436 125.623C180.425 125.567 180.58 125.523 180.79 125.523H189.063C189.273 125.523 189.451 125.567 189.462 125.623L190.115 127.987C190.137 128.043 189.971 128.098 189.761 128.098H189.772Z"
      fill="#4D555A"
    />
    <path
      d="M201.123 128.098H192.695C192.485 128.098 192.297 128.054 192.286 127.987L191.61 125.623C191.588 125.567 191.743 125.523 191.953 125.523H200.226C200.436 125.523 200.614 125.567 200.636 125.623L201.466 127.987C201.489 128.043 201.333 128.098 201.123 128.098Z"
      fill="#4D555A"
    />
    <path
      d="M212.463 128.098H204.036C203.825 128.098 203.637 128.054 203.615 127.987L202.762 125.623C202.74 125.567 202.895 125.523 203.094 125.523H211.367C211.577 125.523 211.755 125.567 211.788 125.623L212.784 127.987C212.807 128.043 212.663 128.098 212.452 128.098H212.463Z"
      fill="#4D555A"
    />
    <path
      d="M220.537 151.125H212.109C211.898 151.125 211.71 151.08 211.688 151.013L210.846 148.649C210.824 148.593 210.979 148.549 211.179 148.549H219.451C219.662 148.549 219.839 148.593 219.872 148.649L220.869 151.013C220.891 151.069 220.747 151.125 220.537 151.125Z"
      fill="#4D555A"
    />
    <path
      d="M221.489 154.233H213.061C212.851 154.233 212.663 154.189 212.64 154.122L211.788 151.757C211.766 151.702 211.921 151.657 212.12 151.657H220.393C220.603 151.657 220.78 151.702 220.813 151.757L221.81 154.122C221.832 154.178 221.688 154.233 221.478 154.233H221.489Z"
      fill="#4D555A"
    />
    <path
      d="M208.421 154.233H199.993C199.783 154.233 199.595 154.189 199.573 154.122L198.731 151.757C198.709 151.702 198.864 151.657 199.063 151.657H207.336C207.546 151.657 207.735 151.702 207.757 151.757L208.753 154.122C208.775 154.178 208.632 154.233 208.421 154.233Z"
      fill="#4D555A"
    />
    <path
      d="M233.804 154.233H225.376C225.166 154.233 224.977 154.189 224.955 154.122L224.103 151.757C224.08 151.702 224.235 151.657 224.435 151.657H232.707C232.918 151.657 233.106 151.702 233.128 151.757L234.125 154.122C234.147 154.178 234.003 154.233 233.793 154.233H233.804Z"
      fill="#4D555A"
    />
    <path
      d="M223.726 128.098H215.298C215.088 128.098 214.9 128.054 214.878 127.987L214.025 125.623C214.003 125.567 214.158 125.523 214.357 125.523H222.63C222.84 125.523 223.028 125.567 223.05 125.623L224.047 127.987C224.069 128.043 223.925 128.098 223.715 128.098H223.726Z"
      fill="#4D555A"
    />
    <path
      d="M77.8866 138.623H64.6415C64.0325 138.623 63.6116 138.435 63.7002 138.201L64.8298 135.415C64.9184 135.193 65.4832 135.004 66.0812 135.004H79.0937C79.6917 135.004 80.1236 135.182 80.0461 135.415L79.1269 138.201C79.0494 138.435 78.4957 138.623 77.8755 138.623H77.8866Z"
      fill="#4D555A"
    />
    <path
      d="M234.468 118.362H57.5318C57.3238 118.362 57.1552 118.531 57.1552 118.739V119.516C57.1552 119.725 57.3238 119.894 57.5318 119.894H234.468C234.676 119.894 234.845 119.725 234.845 119.516V118.739C234.845 118.531 234.676 118.362 234.468 118.362Z"
      fill="#DFDCD8"
    />
    <path
      d="M112.782 95.3577C113.89 94.9025 114.521 93.9033 114.2 93.115C113.879 92.3267 112.727 92.0492 111.619 92.5044C110.523 92.9596 109.881 93.9588 110.213 94.7581C110.534 95.5464 111.686 95.8129 112.782 95.3688V95.3577Z"
      fill="#E0A497"
    />
    <path
      d="M86.6022 91.272C85.6166 88.4187 84.1769 86.5202 82.5157 85.4988C82.5157 85.4988 86.569 85.7431 90.3897 91.7161C94.2103 97.6891 98.2857 96.1348 101.442 95.5353C104.587 94.9247 108.995 93.7922 108.995 93.7922L109.759 96.0127C109.759 96.0127 98.9391 101.675 93.712 100.531C91.7961 100.121 90.3343 99.521 89.2601 98.9326C88.2855 96.1237 87.2999 93.2482 86.6133 91.272H86.6022Z"
      fill="#F1D6CF"
    />
    <path
      d="M160.059 58.1428C152.362 47.6511 137.578 45.3862 127.113 53.1023C117.101 60.4742 114.632 74.341 121.154 84.7106C119.571 85.8874 115.894 88.5853 112.66 90.9834C112.228 90.3949 111.852 89.8731 111.619 89.5512C109.859 90.839 90.5558 105.061 88.806 106.36C89.6366 107.492 92.073 110.812 92.9036 111.945C94.6533 110.657 113.956 96.4235 115.706 95.1356C115.462 94.8026 115.086 94.2918 114.665 93.7034C117.899 91.3164 121.575 88.6186 123.159 87.4417C131.088 96.7788 145.02 98.5329 155.031 91.161C165.497 83.4449 167.756 68.6344 160.059 58.1428ZM153.824 89.5068C144.267 96.5456 130.778 94.4917 123.746 84.9104C116.714 75.3291 118.773 61.8065 128.331 54.7565C137.888 47.7177 151.377 49.7716 158.409 59.3529C165.43 68.9342 163.381 82.4568 153.813 89.5068H153.824Z"
      fill="#3A2F2B"
    />
    <path d="M85.0407 161.727V164.536H87.5324V161.583L85.0407 161.727Z" fill="#E0A497" />
    <path
      d="M85.0407 162.782C85.0407 162.782 84.3762 164.003 84.3762 164.991V167.012H94.4097C94.4097 167.012 94.5979 165.813 93.2136 165.813C91.8293 165.813 89.4262 164.847 88.9721 164.392C88.3962 163.792 87.9754 162.771 87.5324 162.771H85.0407V162.782Z"
      fill="url(#paint0_linear_4668_68011)"
    />
    <path
      d="M86.8458 111.512C86.8458 111.512 92.4163 119.872 92.6488 133.616C92.9589 152.102 88.064 162.882 88.064 162.882H84.5423C83.9775 147.006 86.3585 147.505 85.0296 135.848C83.9886 126.711 75.1069 118.85 75.1069 114.765C75.1069 110.679 86.8458 111.523 86.8458 111.523V111.512Z"
      fill="#3A2F2B"
    />
    <path d="M67.1333 161.394L66.9893 164.192L69.4811 164.325L69.6361 161.383L67.1333 161.394Z" fill="#E0A497" />
    <path
      d="M67.0336 162.538C67.0336 162.538 66.3581 163.626 66.2916 164.614C66.2363 165.602 66.1809 166.634 66.1809 166.634L76.2033 167.167C76.2033 167.167 76.4469 165.979 75.0737 165.913C73.7005 165.835 71.3305 164.747 70.9097 164.27C70.367 163.659 69.9684 162.693 69.5254 162.671C69.0824 162.649 67.0336 162.538 67.0336 162.538Z"
      fill="url(#paint1_linear_4668_68011)"
    />
    <path
      d="M73.1578 117.44C73.1578 117.44 73.5343 125.023 74.83 131.052C76.613 139.367 74.9297 140.244 72.1722 144.596C68.6284 150.192 66.6793 162.593 66.6793 162.593L69.9573 162.815C69.9573 162.815 82.4603 141.621 85.1404 132.217C88.662 119.883 86.9012 114.132 86.9012 114.132L79.3595 113.621L73.1689 117.429L73.1578 117.44Z"
      fill="#3A2F2B"
    />
    <path
      d="M79.0716 84.866C79.0716 84.866 72.9363 86.2871 72.2719 91.05C71.3748 97.5226 72.4933 120.693 72.4933 120.693C72.4933 120.693 82.0174 120.527 89.8027 117.607C89.8027 117.607 89.0829 100.831 89.0829 95.2578C89.0829 89.6844 86.0928 85.7431 82.5711 85.2546C79.7582 84.866 79.0605 84.866 79.0605 84.866H79.0716Z"
      fill="white"
    />
    <path
      d="M86.6908 81.7574C87.4328 78.0714 86.0928 74.4965 86.0928 74.4965C85.528 74.7074 84.1658 74.7629 83.2023 74.9072C82.2389 75.0627 82.3496 76.4505 82.3385 77.1166C82.3274 77.7716 81.9509 79.2593 81.6076 79.4037C81.375 78.6709 81.1868 76.295 80.179 77.2276C79.1712 78.1491 79.5478 78.4933 79.725 79.8922C79.9021 81.2689 78.2521 81.1578 78.2521 81.1578C79.0605 84.433 78.9165 85.6543 78.9165 85.6543C78.9165 85.6543 82.9144 88.3854 82.7815 85.6543C82.7151 84.2776 82.8258 83.5448 82.8258 83.5448C85.1957 84.7772 86.27 83.7891 86.6908 81.7796V81.7574Z"
      fill="#E0A497"
    />
    <path
      d="M86.0928 74.4964C86.0928 74.4964 88.3409 73.8636 88.4405 72.4314C88.507 71.3545 87.8425 69.567 81.4858 69.0563C79.4038 68.8898 77.056 70.1332 76.8456 72.7534C76.8456 72.7534 75.2509 73.8081 75.6274 75.64C75.9929 77.4608 77.4436 78.7486 78.2631 81.1578C78.2631 81.1578 79.9132 81.2689 79.736 79.8922C79.5699 78.5044 79.1823 78.1491 80.1901 77.2276C81.1979 76.3061 81.3972 78.6709 81.6187 79.4037C81.9509 79.2593 82.3385 77.7827 82.3496 77.1166C82.3496 76.4505 82.2389 75.0738 83.2134 74.9072C84.1769 74.7518 85.528 74.6963 86.1038 74.4964H86.0928Z"
      fill="#5B4135"
    />
    <path
      d="M71.9728 95.9683C71.9728 95.9683 69.1932 134.527 67.5209 145.929C67.5209 145.929 77.2 151.158 94.3765 145.24C94.3765 134.948 89.3376 110.312 89.3376 110.312C89.3376 110.312 72.6595 107.204 71.9728 95.9683Z"
      fill="white"
    />
    <path
      d="M89.2711 108.791C89.249 108.381 89.2158 107.959 89.1936 107.537C88.4184 106.438 86.6576 104.861 82.6818 103.929C76.1258 102.397 73.0692 92.3267 73.0692 92.3267C73.0692 92.3267 72.4158 94.5139 72.9585 99.4433C74.7082 109.302 86.6908 108.98 89.2711 108.791Z"
      fill="#F1D6CF"
    />
    <path
      d="M99.8029 107.359C100.999 107.293 101.918 106.549 101.874 105.705C101.818 104.861 100.822 104.217 99.6368 104.284C98.4408 104.351 97.5105 105.094 97.5659 105.938C97.6102 106.793 98.618 107.426 99.8029 107.359Z"
      fill="#F3CABE"
    />
    <path
      d="M72.2276 94.1697C72.2276 91.1388 73.0138 87.9191 74.4314 88.0968C74.4314 88.0968 78.1745 89.6733 79.8357 96.5678C81.4858 103.462 85.8491 103.329 89.0275 103.784C92.2059 104.251 96.7353 104.617 96.7353 104.617V106.971C96.7353 106.971 84.6642 108.758 80.1015 105.971C78.4292 104.95 77.2443 103.906 76.4137 102.996C73.4679 98.9104 72.2386 96.2458 72.2386 94.1586L72.2276 94.1697Z"
      fill="white"
    />
    <path d="M185.597 156.187V159.274H183.05V156.032L185.597 156.187Z" fill="#E0A497" />
    <path
      d="M185.597 157.508C185.597 157.508 186.272 158.685 186.272 159.773V162.005H176.062C176.062 162.005 175.873 160.684 177.28 160.684C178.686 160.684 181.134 159.629 181.599 159.129C182.186 158.474 182.607 157.508 183.061 157.508H185.597Z"
      fill="url(#paint2_linear_4668_68011)"
    />
    <path d="M205.852 156.187V159.274H203.316V156.032L205.852 156.187Z" fill="#E0A497" />
    <path
      d="M205.852 157.431C205.852 157.431 206.527 158.674 206.527 159.773V162.005H196.317C196.317 162.005 196.128 160.684 197.535 160.684C198.941 160.684 201.389 159.629 201.854 159.129C202.441 158.474 202.862 157.431 203.316 157.431H205.852Z"
      fill="url(#paint3_linear_4668_68011)"
    />
    <path
      d="M177.667 103.507C177.667 103.507 177.712 131.262 182.075 157.242C182.075 157.242 184.279 158.197 186.638 157.197C186.638 157.197 185.22 117.884 188.077 103.718C188.077 103.718 182.872 98.9992 177.667 103.507Z"
      fill="#3A2F2B"
    />
    <path
      d="M196.14 100.931C196.14 100.931 200.735 131.285 207.225 157.042C207.225 157.042 204.645 158.186 201.965 157.331C201.965 157.331 181.2 112.311 179.86 102.863C178.52 93.4258 196.151 100.931 196.151 100.931H196.14Z"
      fill="#3A2F2B"
    />
    <path
      d="M210.913 53.7018C210.913 53.7018 202.518 64.3822 194.013 69.8445C184.777 75.7732 183.803 72.2093 178.764 64.5043C174.434 57.8763 172.64 47.0515 172.64 47.0515C172.64 47.0515 170.879 46.6851 169.362 47.9619C169.362 47.9619 169.948 60.8628 178.011 74.5741C178.797 77.9714 175.995 84.766 177.59 105.383C177.59 105.383 190.436 107.97 196.704 101.408C196.704 101.408 192.784 87.2085 196.029 79.6812C199.274 72.1538 208.897 65.2371 213.438 56.1221C213.438 56.1221 212.74 54.4234 210.924 53.6907L210.913 53.7018Z"
      fill="white"
    />
    <path
      d="M215.619 52.6138C214.966 53.8239 213.825 54.4124 213.072 53.9239C212.319 53.4465 212.242 52.0698 212.895 50.8707C213.549 49.6606 214.689 49.0722 215.442 49.5607C216.195 50.0381 216.273 51.4036 215.619 52.6138Z"
      fill="#E0A497"
    />
    <path
      d="M172.064 43.4877C172.152 44.8866 171.521 46.0634 170.646 46.13C169.771 46.1967 168.996 45.1197 168.907 43.7208C168.819 42.322 169.45 41.134 170.325 41.0785C171.2 41.0119 171.975 42.0888 172.064 43.4877Z"
      fill="#E0A497"
    />
    <path
      d="M188.177 74.0634L183.271 73.2974C183.271 73.2974 179.129 84.2886 179.24 95.8239C179.816 104.362 181.156 105.971 181.156 105.971C181.156 105.971 185.641 106.082 186.76 105.705C187.867 105.328 187.125 78.2934 187.125 78.2934L188.177 74.0634Z"
      fill="#AA7744"
    />
    <path
      d="M183.326 65.4814C184.29 61.2403 187.38 58.0983 187.38 58.0983C187.878 58.5868 189.296 59.2752 190.237 59.8969C191.178 60.5186 190.414 61.9286 190.104 62.6281C189.805 63.3275 189.506 65.0817 189.794 65.3814C190.381 64.7153 191.699 62.3061 192.33 63.7605C192.961 65.2149 192.385 65.4036 191.555 66.7803C190.713 68.157 192.518 68.812 192.518 68.812C190.303 71.9096 190.303 71.9762 189.694 72.9976C188.72 74.6185 181.366 76.0396 184.124 71.6764C184.977 70.3331 186.56 69.1562 186.56 69.1562C183.481 69.3339 182.817 67.7795 183.315 65.4591L183.326 65.4814Z"
      fill="#E0A497"
    />
    <path
      d="M187.38 58.0983C187.38 58.0983 185.685 56.7105 186.04 55.5115C186.394 54.3124 189.008 55.7668 191.61 56.0555C194.213 56.3553 198 56.9659 197.978 60.6296C197.978 60.6296 199.163 62.4948 197.911 64.249C196.66 66.0032 194.523 66.6693 192.529 68.8231C192.529 68.8231 190.735 68.157 191.566 66.7914C192.407 65.4147 192.972 65.226 192.341 63.7716C191.71 62.3172 190.381 64.7264 189.805 65.3925C189.517 65.0928 189.805 63.3386 190.115 62.6392C190.414 61.9397 191.189 60.5297 190.248 59.908C189.307 59.2863 187.9 58.5979 187.391 58.1094L187.38 58.0983Z"
      fill="#5B4135"
    />
    <path
      d="M190.636 71.8318L186.649 72.9088L186.261 74.1411L186.793 74.7629C186.793 74.7629 185.541 78.7375 185.486 83.9889C185.253 107.204 188.941 127.343 189.705 132.117C189.705 132.117 202.131 132.728 208.266 124.423C208.266 124.423 197.535 111.045 195.464 91.9048C194.622 81.3687 196.35 79.1483 196.35 79.1483L190.636 71.843V71.8318Z"
      fill="white"
    />
    <path
      d="M177.634 74.0967C177.634 74.0967 172.806 98.9326 173.038 115.186C173.271 125.678 173.149 130.408 173.149 130.408C173.149 130.408 178.321 132.939 183.736 130.985C183.16 124.757 178.52 89.0404 183.349 74.6741C183.736 73.908 184.079 73.8636 184.079 73.8636L184.578 72.6756C184.578 72.6756 184.157 71.7875 183.692 71.2879C183.238 70.7883 177.789 73.9746 177.634 74.0967Z"
      fill="white"
    />
    <path
      d="M208.476 48.9944L221.179 52.2141L219.85 57.7653L222.53 58.4536L226.927 39.9017L224.269 39.2244L222.94 44.7867L210.226 41.567L212.962 30.0428L210.293 29.3545L208.931 35.1277L153.049 20.9944L150.347 26.4124L145.33 25.1578L144.001 27.6447L121.952 22.6265L120.246 22.8041L121.686 23.77L143.414 29.732L143.569 32.5852L148.542 33.8398V39.9572L204.423 54.0904L203.061 59.8636L205.719 60.5297L208.476 48.9944Z"
      fill="#DBDAD9"
    />
    <path d="M158.664 40.9786L160.469 33.3624L162.252 33.8176L160.458 41.4338L158.664 40.9786Z" fill="white" />
    <path d="M166.792 43.0325L168.597 35.4163L170.38 35.8715L168.564 43.4877L166.792 43.0325Z" fill="white" />
    <path d="M174.91 45.0975L176.715 37.4702L178.509 37.9254L176.693 45.5416L174.91 45.0975Z" fill="white" />
    <path d="M183.016 47.1403L184.833 39.5242L186.627 39.9683L184.81 47.5844L183.016 47.1403Z" fill="white" />
    <path d="M191.145 49.1943L192.95 41.5781L194.744 42.0222L192.939 49.6495L191.145 49.1943Z" fill="white" />
    <path d="M199.274 51.2482L201.09 43.632L202.862 44.0761L201.057 51.7034L199.274 51.2482Z" fill="white" />
    <path
      d="M144.001 27.6447L121.952 22.6265L120.246 22.8041L121.686 23.77L143.414 29.732L144.001 27.6447Z"
      fill="white"
    />
    <g opacity="0.5">
      <path
        d="M189.816 32.3521L186.449 31.4861C186.139 31.4084 185.829 31.5749 185.763 31.8636C185.696 32.1522 185.896 32.4409 186.195 32.5186L189.561 33.3846C189.882 33.4623 190.181 33.2958 190.248 33.0182C190.314 32.7185 190.115 32.4298 189.816 32.341V32.3521Z"
        fill="#FAEBD9"
      />
      <path
        d="M207.491 36.8929L192.928 33.1515C192.629 33.0737 192.319 33.2403 192.241 33.5289C192.175 33.8176 192.374 34.1063 192.684 34.184L207.247 37.9254C207.557 38.0032 207.867 37.8366 207.934 37.548C208.011 37.2482 207.812 36.9595 207.491 36.8818V36.8929Z"
        fill="#FAEBD9"
      />
    </g>
    <g opacity="0.55">
      <path
        d="M148.542 39.9572L172.23 45.9413L176.792 27.0008L153.049 20.9944L150.347 26.4124L148.542 33.8398V39.9572Z"
        fill="#C4AF8A"
      />
    </g>
    <g opacity="0.5">
      <path d="M182.23 28.3997L177.667 47.3291L172.23 45.9413L176.792 27.0008L182.23 28.3997Z" fill="black" />
    </g>
    <g opacity="0.5">
      <path d="M149.117 26.1126L150.347 26.4124L148.542 33.8398L147.323 33.54L149.117 26.1126Z" fill="#CAB398" />
    </g>
    <path
      d="M153.824 89.5068C144.267 96.5456 130.778 94.4917 123.746 84.9104C116.714 75.3291 118.773 61.8065 128.331 54.7566C137.888 47.7177 151.377 49.7716 158.409 59.3529C165.43 68.9342 163.381 82.4568 153.813 89.5068H153.824Z"
      fill="#A8A8A8"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4668_68011"
        x1="94.4097"
        y1="164.902"
        x2="84.3762"
        y2="164.902"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#51321E" />
        <stop offset="1" stop-color="#480600" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4668_68011"
        x1="76.3163"
        y1="165.12"
        x2="66.2859"
        y2="164.585"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#51321E" />
        <stop offset="1" stop-color="#480600" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4668_68011"
        x1="176.062"
        y1="159.762"
        x2="186.272"
        y2="159.762"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#51321E" />
        <stop offset="1" stop-color="#480600" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4668_68011"
        x1="196.317"
        y1="159.718"
        x2="206.527"
        y2="159.718"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#51321E" />
        <stop offset="1" stop-color="#480600" />
      </linearGradient>
    </defs>
  </svg>
);
